<template>
  <v-toolbar id="core-toolbar" flat prominent style="background: #eee;">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn v-if="responsive" class="default v-btn--simple" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-btn v-ripple flat class="toolbar-items" @click="logout">
          <v-icon medium color="tertiary">mdi-logout</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CoreToolbar",

  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  computed: {
    items() {
      return this.$t("Layout.View.items");
    }
  },

  watch: {
    $route(val) {
      this.title = val.name;
    }
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", [
      "setDrawer",
      "toggleDrawer",
      "setAuth",
      "setAlert"
    ]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },

    logout() {
      Bus.$emit("logout");
      this.$store.dispatch("logout").then(() => {
        this.setAlert({
          status: true,
          text: "Logout Berhasil",
          type: "success"
        });
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>
